import styled from 'styled-components';
import Button from '../../StoraEnsoComponents/Button';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { ReactComponent as FilePdfSvg } from '../../../assets/icons/file-pdf.svg';
import logo from '../../StoraEnsoComponents/assets/images/logo.png'
import { useEffect } from 'react';

const FileIcon = styled(FilePdfSvg)``;

function ExportTableToPDF({tableData, headers, missionName, missionDate, title, type}) {

  useEffect(()=>{
    console.log("HEADERS",headers);
  },[headers])
  const exportPDF = () => {

    //general configuration
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape
    const marginLeft = 40;
    const marginTop = 30;
    const imageSize = 60;
    const doc = new jsPDF(orientation, unit, size);
    let header2Text = "";
    let header3Text = "";

    // Date to title
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const d = new Date();
    const currentMonthName = monthNames[d.getMonth()];

    //Shorten filename title
    let shortTitle = title.replace(/\s/g, '');
    let fileName = shortTitle + "_" + currentMonthName + d.getUTCFullYear() + ".pdf";

    //check input values && modify text
    if(typeof(missionName)  === 'undefined' && missionName == null){
      return console.log("Error in the addition");
    }

    header2Text = missionName;
    header3Text = missionDate;

    if(type === 'UsrLog'){
      header2Text = missionName.email;
      header3Text = d.toLocaleString("en-GB") + "";
    }

    //Export content
    let content = {
      startY: 100,
      head: [headers],
      body: tableData,
      margin: {top: 100}, //top maintain the header margin on multiple pages
      didDrawPage: function (data) {

        // Page Sizes
        let pageSize = doc.internal.pageSize;
        let pageWidth = pageSize.width;
        let pageHeight = pageSize.height;

        // Header
        doc.setFontSize(20);
        doc.setTextColor(40);
        doc.text(title, marginLeft, marginTop);
        doc.addImage(logo, 'JPEG', pageWidth - 90, 20, imageSize - 10, imageSize);
        doc.setFontSize(15);
        doc.text(header2Text, marginLeft, marginTop + 20);
        doc.setFontSize(10);
        doc.text(header3Text, marginLeft, marginTop + 40);

        // Footer
        let str = "Page " + doc.internal.getNumberOfPages();
        doc.text(str, marginLeft, pageHeight - 20);
      }
    };
    doc.autoTable(content);
    doc.save(fileName);
  }

  return (
    <div>
      <Button icon={<FileIcon />} onClick={exportPDF} size="sm">Generate Report</Button>
    </div>
  )
}
export default ExportTableToPDF;